import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardView from "@/views/dashboard/DashboardView";
import SignupView from "@/views/auth/SignupView";
import SigninView from "@/views/auth/SigninView";
import ProfileView from "@/views/profile/ProfileView";
import ProfileGeneral from "@/components/profile/ProfileGeneral";
import ProfileExchanges from "@/components/profile/ProfileExchanges";
import ProfileSecurity from "@/components/profile/ProfileSecurity";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignupView
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: SigninView
  },
  {
    path: '/profile',
    component: ProfileView,
    children: [
      {
        path: '',
        component: ProfileGeneral
      },
      {
        path: 'exchanges',
        component: ProfileExchanges
      },
      {
        path: 'security',
        component: ProfileSecurity
      }
    ]
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
